import { ColDef } from 'ag-grid-enterprise';
import { format } from 'date-fns';
import { ValuationEventResponse } from '~/api/def/endpoints/portfolioCompanyEndpoint';
import { formatCurrency } from '~/lib/money';

export const colDefsShareIssuanceTable: ColDef<ValuationEventResponse>[] = [
  {
    field: 'valuationDate',
    headerName: 'Valuation Date',
    sortable: true,
    filter: true,
    width: 180,
    autoHeight: true,
    cellClass: 'flex align-items-center justify-content-left',
    wrapText: true,
    valueFormatter: (p) => (p.value ? format(p.value, 'yyyy-MM-dd') : '-'),
  },
  {
    field: 'settlementDate',
    headerName: 'Settlement Date',
    sortable: true,
    filter: true,
    width: 180,
    autoHeight: true,
    cellClass: 'flex align-items-center justify-content-left',
    wrapText: true,
    valueFormatter: (p) => (p.value ? format(p.value, 'yyyy-MM-dd') : '-'),
  },
  {
    field: 'shares',
    headerName: 'Shares',
    sortable: true,
    cellClass: 'flex align-items-center justify-content-left',
    width: 120,
    filter: true,
    valueFormatter: (p) =>
      p.value
        ? new Intl.NumberFormat('en-GB').format(
            Number(parseFloat(p.value).toFixed(0)),
          )
        : '-',
  },
  {
    field: 'pricePerShare',
    headerName: 'Price Per Share',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    width: 120,
    sortable: true,
    filter: true,
    valueFormatter: (p) =>
      p.value ? Number(parseFloat(p.value).toFixed(2)).toString() : '-',
  },
  {
    field: 'totalValue',
    headerName: 'Total Value',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    width: 120,
    sortable: true,
    filter: true,
    valueFormatter: (p) =>
      typeof p.value === 'number'
        ? formatCurrency(p.data?.currency ?? 'EUR', p.value)
        : '-',
  },
  {
    field: 'securityType',
    headerName: 'Security',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w120',
    sortable: true,
    filter: true,
    valueFormatter: (p) => p.value || '-',
  },
  {
    field: 'schema',
    headerName: 'Schema',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w120',
    sortable: true,
    filter: true,
    valueFormatter: (p) => p.value || '-',
  },
  {
    field: 'fullyDiluted',
    headerName: 'Fully Diluted',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w120',
    sortable: true,
    filter: true,
    valueFormatter: (p) => p.value || '-',
  },
  {
    field: 'shareClass',
    headerName: 'Class',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w120',
    sortable: true,
    filter: true,
    valueFormatter: (p) => (p.value ? p.value.replace('_', ' ') : '-'),
  },
  {
    field: 'round',
    headerName: 'Round',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w120',
    sortable: true,
    filter: true,
    valueFormatter: (p) => p.value || '-',
  },
  {
    field: 'adjustmentFactor',
    headerName: 'Adjustment Factor',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w120',
    sortable: true,
    filter: true,
    valueFormatter: (p) =>
      p.value ? Number(parseFloat(p.value).toFixed(2)).toString() : '-',
  },
  {
    field: 'recipient',
    headerName: 'Recipient',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    width: 150,
    sortable: true,
    filter: true,
    valueFormatter: (p) => p.value || '-',
  },
  {
    field: 'note',
    headerName: 'Notes',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    width: 150,
    sortable: true,
    filter: true,
    valueFormatter: (p) => p.value || '-',
  },
];
